import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Terminal from "../Terminal/Terminal";
import Footer from "../Footer/Footer";
import "./Layout.css";

const Layout = ({ children }) => {
  const [missionTime, setMissionTime] = useState("00:00:00");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [terminalOpen, setTerminalOpen] = useState(false);

  useEffect(() => {
    // Event date and time: February 7, 2026 at 6:00 PM
    const eventDate = new Date("2026-02-07T18:00:00");
    
    const calculateTimeRemaining = () => {
      const now = new Date();
      const difference = eventDate - now;

      if (difference <= 0) {
        // Event has started or ended
        const endDate = new Date("2026-02-08T18:00:00");
        const timeUntilEnd = endDate - now;
        
        if (timeUntilEnd <= 0) {
          setMissionTime("EVENT ENDED");
          return;
        }
        
        // Show time until event ends
        const days = Math.floor(timeUntilEnd / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeUntilEnd % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeUntilEnd % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeUntilEnd % (1000 * 60)) / 1000);
        
        if (days > 0) {
          setMissionTime(
            `${String(days).padStart(2, "0")}d ${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
          );
        } else {
          setMissionTime(
            `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
          );
        }
      } else {
        // Show countdown to event start
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        if (days > 0) {
          setMissionTime(
            `${String(days).padStart(2, "0")}d ${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
          );
        } else {
          setMissionTime(
            `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
          );
        }
      }
    };

    // Calculate immediately
    calculateTimeRemaining();

    // Update every second
    const timer = setInterval(calculateTimeRemaining, 1000);

    return () => clearInterval(timer);
  }, []);

  const toggleSidebar = () => {
    console.log("Toggle sidebar clicked, current state:", sidebarOpen);
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const toggleTerminal = () => {
    setTerminalOpen(!terminalOpen);
  };

  const closeTerminal = () => {
    setTerminalOpen(false);
  };

  return (
    <div className="layout">
      <Header
        missionTime={missionTime}
        onMenuClick={toggleSidebar}
        onTerminalClick={toggleTerminal}
      />
      <div className="layout-content">
        <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
        <main className="main-content">{children}</main>
      </div>
      <Footer />
      <Terminal isOpen={terminalOpen} onClose={closeTerminal} />
    </div>
  );
};

export default Layout;
